import React, { Component } from 'react';
import Page from '../../components/Page/Page';

class PageNotFound extends Component {
  render() {
    return (
      <Page primaryTitle="404" secondaryTitle="" section="">
        <div className="pageNotFound">
          <h2>Uh oh...</h2>
          <p>The page you requested doesn't seem to exist.</p>
          <p>We may have moved this page, or deleted it.</p>
        </div>
      </Page>
    );
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/PageNotFound.js